import { Box } from '@mui/material'
import SignUpCard from '../components/signup/SignUpCard'

const SignUpPage = () => {
  return (
    <Box display="flex" justifyContent="center" p="30px">
      <SignUpCard />
    </Box>
  )
}

export default SignUpPage
